import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Verify_OTP = () => {
    const [otp, setOtp] = useState("");
    const Navigate = useNavigate();
    useEffect(()=>{
        const auth = localStorage.getItem('token');
        if(auth){
            Navigate('/home')
        }
    })
    const callotpapi = () => {
        console.log(otp);
        Navigate('/changePassword');

    }

    return (
        <>
            <div className="register">
                <label htmlFor="Otp-field" className="labelBox" >Enter Otp Sent to Your Mobile</label>
                <input
                    className="inputbox"
                    type="number"
                    id="Otp-field"
                    name="otp"
                    maxLength="4"
                    value={otp}
                    onChange={e => setOtp(e.target.value)}
                    placeholder="Enter the 4-digit Otp"
                    required
                />

                <button onClick={() => setOtp(() => "")} className="submitButton" type="clear" >clear</button>
                <button onClick={callotpapi} className="submitButton" type="submit" >verify otp</button>


            </div>
        </>
    );
};

export default Verify_OTP;